export default "__VITE_ASSET__1246ccc5__"